/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StatusEnum } from './statusEnum';

export interface SMPPClientCredential { 
    id?: string;
    routeId?: string;
    systemId?: string;
    password?: string;
    dateCreated?: Date;
    agreggatorId?: string;
    entityStatusEnum?: StatusEnum;
    serviceProviderEmail?: string;
    serviceProviderName?: string;
    serviceProviderId?: string;
}